export const STEP_HEADER_CARD_SX = {
  mb: 2,
  borderRadius: 2,
  backgroundColor: "#f8fafc",
};

export const STEP_HEADER_CONTENT_SX = {
  py: 2,
};

export const STEP_HEADER_TITLE_SX = {
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: 0.5,
};

export const STEP_HEADER_SUBTITLE_SX = {
  mt: 0.5,
};

export const STEP_ACTION_BAR_SX = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  mt: 2,
  mb: 2,
  mr: 2,
  gap: 1,
};

export const STEP_ACTION_BUTTON_SX = {
  fontSize: "0.875rem",
};

export const STEP_CANCEL_BUTTON_SX = {
  fontSize: "0.875rem",
  color: "#FF4C4C",
  borderColor: "#FF4C4C",
};

export const STEP_CLOSE_BUTTON_SX = {
  fontSize: "0.875rem",
  px: 3,
};